var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "preview-practice pa-4 rounded-lg bg-gray-0",
      attrs: { "data-qa": "preview_practice" },
    },
    [
      _c(_setup.PracticeLogoBadge, { staticClass: "mb-1" }),
      _vm._v(" "),
      _c("h3", { staticClass: "text-subtitle-1 mb-4" }, [
        _vm._v("\n    Врач чаще всего лечит\n  "),
      ]),
      _vm._v(" "),
      _c(_setup.DiagramGender, { staticClass: "mb-4" }),
      _vm._v(" "),
      _c(_setup.DiagramAgeStacked, { staticClass: "mb-4" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "position-relative mb-2" },
        [
          _c(_setup.DiseasesStatistics, {
            attrs: { limit: 5, "show-code": false, compact: "" },
          }),
          _vm._v(" "),
          _setup.hasMoreDiseases
            ? _c("div", { staticClass: "preview-practice__fade" })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "d-flex align-center gc-1 pa-0 cursor-pointer preview-practice__more",
          attrs: { type: "button", "data-qa": "preview_practice_show_more" },
          on: {
            click: function ($event) {
              return _vm.$emit("click:show-more")
            },
          },
        },
        [
          _c("span", { staticClass: "text-body-2 primary--text" }, [
            _vm._v("\n      Смотреть все\n    "),
          ]),
          _vm._v(" "),
          _c("span", {
            staticClass: "ui-icon-arrow-right ui-icon-fz-medium primary--text",
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }